export default "__VITE_ASSET__BYRx2Ed7__"